import React, { useEffect, useState } from 'react';
import { Button, Card, Form, Input, Space } from 'antd';
import { defaultValidateMessages } from 'constants/validate/message';
import { Link } from 'react-router-dom';
import { EPath } from 'constants/routes';
import { TControlInitState } from 'modules/controlInit/controlInit.reducer';
import { TGroupsClassDetail } from 'types/groupsClass';
import ModalUploadControlInit from './ModalUploadControlInit';
import styles from './style.module.scss';

type Props = {
  id: string;
  currentGroup: TGroupsClassDetail;
  controlInitState: TControlInitState;
  uploadFileControlInit: (file: FormData) => void;
  createControlInit: (data: { name?: string; fname?: string; groupId: number }) => void;
  getDetailControlInit: (data: { ctrRsId: number; groupId: number }) => void;
  updateControlInit: (data: { ctrRsId: number; name?: string; fname?: string; groupId: number }) => void;
  updateDataFileUpload: () => void;
};
const AdmControlInitDetails = ({
  id,
  currentGroup,
  controlInitState,
  createControlInit,
  getDetailControlInit,
  updateControlInit,
  uploadFileControlInit,
  updateDataFileUpload,
}: Props) => {
  const [form] = Form.useForm();
  const [openModal, setOpenModal] = useState<boolean>(false);

  const handleSubmit = (values: { name: string }) => {
    const { fname } = controlInitState.dataFileUpload;

    if (!id && fname && currentGroup.id) {
      createControlInit({ ...values, fname, groupId: currentGroup.id });
      return;
    }
    if (id && currentGroup.id) {
      const dataUpdate = fname ? { ...values, fname, ctrRsId: Number(id) } : { ...values, ctrRsId: Number(id) };
      updateControlInit({ ...dataUpdate, groupId: currentGroup.id });
    }
  };
  useEffect(() => {
    updateDataFileUpload();
  }, []);

  useEffect(() => {
    if (id && currentGroup.id) {
      getDetailControlInit({ ctrRsId: Number(id), groupId: currentGroup.id });
    }
  }, [id, currentGroup.id]);

  useEffect(() => {
    if (id) {
      form.setFieldValue('name', controlInitState.controlInitDetail.name);
    }
  }, [controlInitState.controlInitDetail, id]);
  return (
    <>
      <ModalUploadControlInit
        uploadFileControlInit={uploadFileControlInit}
        open={openModal}
        setModal={setOpenModal}
        clearStateUpload={() => {}}
      />
      <div className={styles.groups}>
        <Card
          className={styles.groups__wrap}
          title={
            <div className={styles.assignmentsMenuTitle}>
              <p>制御初期データ登録</p>
            </div>
          }
          loading={false}
        >
          <div className={styles.content}>
            <div className={styles.top}>
              <Space className={styles.topButtonGroup}>
                <Button className={styles.topButton}>
                  <Link to={EPath.A10_1}>制御初期データ管理に戻る</Link>
                </Button>
              </Space>
              <Form
                autoComplete="off"
                layout="vertical"
                form={form}
                onFinish={handleSubmit}
                validateMessages={defaultValidateMessages}
                disabled={false}
              >
                <Form.Item>
                  <Space direction="vertical" align="start" className={styles.assignmentItem}>
                    <p className={styles.assignmentTitle}>制御初期データ名</p>
                    <Form.Item name="name" rules={[{ required: true, whitespace: true }]} noStyle>
                      <Input className={styles.assignmentItemWidth} placeholder="制御初期データ名を入力してください" />
                    </Form.Item>
                  </Space>
                </Form.Item>

                <div className={styles.body}>
                  <p>
                    制御初期データのファイルをアップロードしてください。 <br />
                    （CSV形式。添付可能な最大サイズは500KBです。）
                  </p>
                  <div className={styles.uploadGroup}>
                    <Button className={styles.topButton} onClick={() => setOpenModal(true)}>
                      ファイルを選択
                    </Button>
                    <p>
                      {controlInitState.dataFileUpload.originalName
                        ? controlInitState.dataFileUpload.originalName
                        : '選択されていません。'}
                    </p>
                  </div>
                </div>
                <Form.Item noStyle>
                  <button disabled={false} type="submit" className={styles.confirmButton}>
                    保存する
                  </button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
};

export default AdmControlInitDetails;
